import { detectEnv } from '@/shared/detect';
import ResizeObserver from 'resize-observer-polyfill';
import yxhJsBridge from '@/shared/yxhJsBridge';

type PropertyType = 'top' | 'bottom';

const properties: PropertyType[] = ['top', 'bottom'];

async function setProperty(property: PropertyType, value: number) {
  let val = value;

  if (detectEnv.yxh && val === 0) {
    const safeAreaInset = await yxhJsBridge.getSafeAreaInset();

    if (safeAreaInset[property] > 0) {
      val = safeAreaInset[property];
    }
  }

  document.documentElement.style.setProperty(`--safe-area-inset-${property}`, `${val}px`);
}

/**
 * 安全区距离监听器
 */
const detectorMap = new Map<PropertyType, HTMLDivElement>();
function observeSafeAreaInset(property: PropertyType) {
  const detector = document.createElement('div');

  detector.id = `__safe-area-inset-${property}-detector__`;
  detector.style.cssText = `
    position: fixed;
    left: -999%;
    top: -999%;
    height: constant(safe-area-inset-${property});
    height: env(safe-area-inset-${property});
  `;
  document.body.appendChild(detector);
  detectorMap.set(property, detector);

  setProperty(property, detector.clientHeight);

  const observer = new ResizeObserver((entries) => {
    if (Array.isArray(entries)) {
      entries.forEach((entry) => {
        setProperty(property, entry.contentRect.height);
      });
    }
  });
  observer.observe(detector);
}

/**
 * 刷新安全区距离尺寸
 */
export function refreshSafeAreaInsetProperty() {
  properties.forEach((property) => {
    setProperty(property, detectorMap.get(property)?.clientHeight ?? 0);
  });
}

/**
 * 初始设置安全区距离尺寸
 */
export default function setupSafeAreaInsetProperty() {
  const isSupportCSSVariables = !!(
    window.CSS?.supports?.('--a', '0px') || window.CSS?.supports('--a : 0px')
  );

  if (isSupportCSSVariables) {
    (properties as PropertyType[]).forEach((property) => observeSafeAreaInset(property));
  } else {
    // 宜享花APP内不支持CSS变量的情况下显示安全区距离
    if (detectEnv.yxh) {
      yxhJsBridge.showSafeAreaInset();
    }
  }
}
